
import { defineComponent } from 'vue'
import QDialog from 'quasar/src/components/dialog/QDialog.js';import QCard from 'quasar/src/components/card/QCard.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QList from 'quasar/src/components/item/QList.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';
import RedirectItemSection from './RedirectItemSection.vue';
import { ColorBlindDataKey, injectStrict } from '@/utils/Injection';

export default defineComponent({
    components: {
        QDialog, 
        QCard,
        QBtn,
        QCardSection,
        QItemSection, 
        QItem,
        QSeparator,
        QList,
        QToggle,
        RedirectItemSection,
    },
    emits: [
        ...useDialogPluginComponent.emits,
    ],
    setup() {
        const { dialogRef, onDialogHide } = useDialogPluginComponent();
        const colorBlindData = injectStrict(ColorBlindDataKey);
        return { dialogRef, onDialogHide, colorBlindData };
    },
    methods: {
        toggle() {
            this.colorBlindData.toggle();
        }
    }
})
